export default {
  constReason: (state) => state.constReason,
  // statusRefunds: state => state.statusRefunds,
  // isShowItemStatus: state => state.isShowItemStatus,
  // isShowItemTypeService: state => state.isShowItemTypeService,
  // typeService: state => state.typeService,
  // typePayment: state => state.typePayment,
  // isShowTypePayment: state => state.isShowTypePayment,
  // store: state => state.store,
  // isShowStore: state => state.isShowStore,
  // isShowExtend: state => state.isShowExtend,
  // isShowPopUpRefund: state => state.isShowPopUpRefund,
  // filters: state => state.filters,
  // paginations: state => state.paginations,
  // transactions: state => state.transactions,
  // totalAmount: state => { state.totalAmount;},
  // totalFeeAmount: state => state.totalFeeAmount,
  // totalOrderAmount: state => state.totalOrderAmount,
  // nameStore: state => state.nameStore,
  // nameType: state => state.nameType,
};
